module.exports = __webpack_public_path__ + "img/hb2.ef6b16a3.jpg";